import { Controller } from "stimulus"

export default class extends Controller {
  static targets = []

  togglePasswordFields(e) {
    e.preventDefault()
    let currentItem = e.target.getParent('.password-section')
    let currentSetting = currentItem.querySelector('.password-fields')
    currentSetting.classList.toggle('hidden')
    let currentPassword = currentSetting.querySelector('#current_password')
    currentPassword.children[1].disabled = false
    e.target.hide()
  }
}